(function () {
    'use strict';

    angular
        .module('partners')
        .controller('PartnerDashboardAttendedModalController', PartnerDashboardAttendedModalController)

    PartnerDashboardAttendedModalController.$inject = ['$uibModalInstance', 'partner'];

    function PartnerDashboardAttendedModalController($uibModalInstance, partner) {
        var vm = this;

        vm.ok      = ok;
        vm.cancel  = cancel;
        vm.partner = partner;

        activate();


        function activate() {
        }


        function ok () {
            $uibModalInstance.close();
        }


        function cancel () {
            $uibModalInstance.close();
        }

    }

})();